import React from 'react';

const AppStoreButton = () => {
    return (
        <div className={'store_button_wrapper'}>
        <button
            className={'store_button'}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
                <path
                    d="M15.9982 12.303C16.0095 11.4285 16.2418 10.5711 16.6735 9.81057C17.1052 9.05001 17.7222 8.41099 18.4672 7.95297C17.994 7.27702 17.3698 6.72071 16.644 6.32822C15.9182 5.93573 15.1109 5.71788 14.2862 5.69197C12.5242 5.50997 10.8242 6.74797 9.92422 6.74797C9.01022 6.74797 7.63022 5.71397 6.14322 5.74797C5.18229 5.77897 4.24575 6.05821 3.42475 6.55852C2.60375 7.05883 1.92626 7.76316 1.45822 8.60297C-0.56778 12.111 0.94322 17.267 2.88422 20.103C3.85522 21.492 4.99022 23.043 6.47522 22.988C7.92822 22.928 8.47522 22.061 10.2252 22.061C11.9632 22.061 12.4722 22.988 13.9872 22.953C15.5462 22.928 16.5292 21.558 17.4662 20.153C18.164 19.1636 18.701 18.0701 19.0572 16.913C18.151 16.5298 17.3777 15.8883 16.8337 15.0685C16.2897 14.2487 15.9991 13.2869 15.9982 12.303Z"
                    fill="#191919"/>
                <path
                    d="M13.1365 3.82997C13.9873 2.80963 14.4064 1.49757 14.3045 0.172974C13.0057 0.309612 11.8061 0.930506 10.9445 1.91197C10.5229 2.39135 10.1998 2.94917 9.9939 3.55351C9.788 4.15785 9.70326 4.79685 9.74454 5.43397C10.394 5.44109 11.0365 5.30079 11.6239 5.02365C12.2113 4.74651 12.7281 4.33975 13.1355 3.83397L13.1365 3.82997Z"
                    fill="#191919"/>
            </svg>
            <div className={'store_button_titles'}>
                <span className={'store_button_titles_action'}>Download on the</span>
                <span className={'store_button_titles_store'}>App Store</span>
            </div>
        </button>
            <span className={'coming_soon'}>Coming Soon</span>
        </div>
    );
};

export default AppStoreButton;